import React from "react";
import {Quotation} from "../model/quotation";
import {Stage} from "../api/model/scenario";

interface Props {
	nextStepListener: (quotation: Quotation) => void;
	backStepListener: (quotation: Quotation, stepCallback?: (stage: Stage) => void) => void;
}

export const StepContext = React.createContext<Props>({
	nextStepListener: (quotation: Quotation) => {},
	backStepListener: (quotation: Quotation) => {}
});
